"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.SMALL = exports.INVERTED_DISABLED = exports.DISABLED = exports.INVERTED = exports.SECONDARY = exports.PRIMARY = exports.COLORS_MAP = exports.ICON = exports.DEFAULT = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    DEFAULT = (0, _cxs["default"])({
  alignItems: "center",
  border: "none",
  borderRadius: "25px",
  cursor: "pointer",
  display: "flex",
  justifyContent: "center",
  userSelect: "none",
  height: "50px",
  width: "240px",
  fontSize: "17px",
  padding: "2px 7px"
});

exports.DEFAULT = DEFAULT;
var ICON = (0, _cxs["default"])({
  marginRight: "10px"
});
exports.ICON = ICON;
var COLORS_MAP = {
  PRIMARY: "white",
  SECONDARY: "white",
  INVERTED: "black"
};
exports.COLORS_MAP = COLORS_MAP;
var PRIMARY = (0, _cxs["default"])({
  background: _vars.COLOURS.cyan.jungleGreen.monkey,
  color: _vars.COLOURS.mono.white,
  ":hover": {
    background: _vars.COLOURS.cyan.turquoise
  },
  ":focus": {
    background: _vars.COLOURS.cyan.jungleGreen.parrot
  }
});
exports.PRIMARY = PRIMARY;
var SECONDARY = (0, _cxs["default"])({
  background: _vars.COLOURS.mono.black,
  border: "1px solid ".concat(_vars.COLOURS.mono.black),
  color: _vars.COLOURS.mono.white
});
exports.SECONDARY = SECONDARY;
var INVERTED = (0, _cxs["default"])({
  background: _vars.COLOURS.mono.white,
  border: "1px solid ".concat(_vars.COLOURS.grey.mischka.michael),
  color: _vars.COLOURS.mono.black,
  ":hover": {
    background: _vars.COLOURS.mono.white,
    border: "1px solid ".concat(_vars.COLOURS.grey.regent),
    color: _vars.COLOURS.mono.black
  },
  ":focus": {
    background: _vars.COLOURS.mono.white,
    border: "1px solid ".concat(_vars.COLOURS.grey.regent),
    color: _vars.COLOURS.mono.black
  }
});
exports.INVERTED = INVERTED;
var DISABLED = (0, _cxs["default"])({
  background: _vars.COLOURS.grey.athens.bigFat,
  borderColor: _vars.COLOURS.grey.athens.bigFat,
  cursor: "default",
  ":hover": {
    background: _vars.COLOURS.grey.athens.bigFat
  },
  ":focus": {
    background: _vars.COLOURS.grey.athens.bigFat
  },
  pointerEvents: "none"
});
exports.DISABLED = DISABLED;
var INVERTED_DISABLED = (0, _cxs["default"])({
  background: _vars.COLOURS.grey.mineShaft
});
exports.INVERTED_DISABLED = INVERTED_DISABLED;
var SMALL = (0, _cxs["default"])({
  borderRadius: "4px",
  fontSize: _vars.FONT_SIZES.small,
  fontWeight: _vars.FONT_WEIGHTS.medium,
  width: "155px",
  height: "35px"
});
exports.SMALL = SMALL;